// External link
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


// Define the custom element
class AbzAgeVerificationPopup extends HTMLElement {
    constructor() {
        super();
        this.popup = null;
        this.verifyButton = null;
        this.monthInput = null;
        this.dayInput = null;
        this.yearInput = null;
        this.rememberMe = null;
        this.inputs = [];
    }

    connectedCallback() {
        // Initialize elements after DOM is loaded
        this.popup = this.querySelector('#ageVerificationPopup');
        this.verifyButton = this.querySelector('#verifyAge');
        this.monthInput = this.querySelector('#month');
        this.dayInput = this.querySelector('#day');
        this.yearInput = this.querySelector('#year');
        this.rememberMe = this.querySelector('#rememberMe');
        this.inputs = [this.monthInput, this.dayInput, this.yearInput];

        // Check if user is already verified and verification hasn't expired
        const verifiedData = localStorage.getItem('ageVerified');
        const AvpPassThrough = new URLSearchParams(window.location.search).get('AvpPassThrough') === '1';

        if (verifiedData) {
            const { timestamp, rememberMe } = JSON.parse(verifiedData);
            const timeLimitMs = rememberMe ? 30 * 24 * 60 * 60 * 1000 : 24 * 60 * 60 * 1000; // 30 days or 24 hours

            if (Date.now() - timestamp < timeLimitMs) {
                this.classList.add('hidden');
            } else {
                localStorage.removeItem('ageVerified');
                this.classList.remove('hidden');
            }
        } else {
            if (AvpPassThrough){
            }
            else{
              this.classList.remove('hidden');
            }
        }

        // Set up event listeners
        this.setupInputValidation();
        this.setupVerifyButton();
    }

    setupInputValidation() {
        this.inputs.forEach(input => {
            input.addEventListener('input', (e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                if (e.target.value.length === e.target.maxLength) {
                    const currentIndex = this.inputs.indexOf(e.target);
                    const next = this.inputs[currentIndex + 1];
                    if (next) next.focus();
                }
            });
        });
    }

    setupVerifyButton() {
        this.verifyButton.addEventListener('click', () => {
            const month = parseInt(this.monthInput.value);
            const day = parseInt(this.dayInput.value);
            const year = parseInt(this.yearInput.value);

            const birthDate = new Date(year, month - 1, day);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();

            // Adjust age for months and days
            if (today.getMonth() < birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
                age--;
            }

            if (this.isValidDate(month, day, year) && age >= 18) {
                localStorage.setItem('ageVerified', JSON.stringify({
                    timestamp: Date.now(),
                    rememberMe: this.rememberMe.checked
                }));
                this.classList.add('hidden');
            } else {
                alert('You must be 18 or older to enter this site.');
            }
        });
    }

    isValidDate(month, day, year) {
        const date = new Date(year, month - 1, day);
        return date.getMonth() === month - 1 &&
            date.getDate() === day &&
            date.getFullYear() === year;
    }
}

// Register the custom element
customElements.define('abz-age-verification-popup', AbzAgeVerificationPopup);

document.querySelectorAll('[id^="QuickShopModal-"]').forEach(modal => {
  document.body.append(modal);
});
document.querySelectorAll('.grid-product').forEach(trigger => {
  trigger.dispatchEvent(new Event('mouseover'))
});

// Instant Add to Cart Web Component
class InstantAddToCart extends HTMLElement {
  constructor() {
    super();
    this.addToCart = this.addToCart.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.addToCart);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.addToCart);
    document.removeEventListener('cart:updated', this.handleCartUpdate);
  }

  async addToCart(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.classList.contains('btn--loading') || this.hasAttribute('disabled')) {
      return;
    }

    const variantId = this.getAttribute('data-variant-id');
    if (!variantId) return;

    this.classList.add('btn--loading');

    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();
      this.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { variantId, quantity: 1 },
        bubbles: true
      }));

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error, Please Try Again')
    } finally {
      this.classList.remove('btn--loading');
    }
  }
}

// Register the custom element
if (!customElements.get('instant-add-to-cart')) {
  customElements.define('instant-add-to-cart', InstantAddToCart);
}

// Video Wrapper Custom Element
class AbzPageVideoWrapper extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.toggleBtn = this.querySelector('.video-play-toggle');
    
    // Initialize based on autoplay setting
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    if (!autoplay) {
      this.classList.add("paused");
    }

    // Bind event listeners
    // this.toggleBtn.addEventListener('click', this.togglePlay.bind(this));
    // this.video.addEventListener('click', this.togglePlay.bind(this));
    this.addEventListener('click', this.togglePlay.bind(this));
  }

  togglePlay() {
    if (this.video.paused) {
      this.video.play();
      this.classList.remove("paused");
    } else {
      this.video.pause();
      this.classList.add("paused");
    }
  }
}

// Register the video wrapper custom element
customElements.define('abz-page-video-wrapper', AbzPageVideoWrapper);

// Rabbit Image Visibility
document.addEventListener('DOMContentLoaded', function() {
  const rabbitImage = document.querySelector('.rabbit-img');
  const firstImageTextLine = document.querySelector('.abz-image-text-line .feature-row-wrapper');
  const lastFoundersStoryTextAll = document.querySelectorAll('.abz-founders-story-text');
  const lastFoundersStoryText = lastFoundersStoryTextAll[lastFoundersStoryTextAll.length - 1];

  if (!rabbitImage || !firstImageTextLine || !lastFoundersStoryText) {
    console.warn('Required elements not found');
    return;
  }

  function checkVisibility() {
    const firstRect = firstImageTextLine.getBoundingClientRect();
    const lastRect = lastFoundersStoryText.getBoundingClientRect();

    // Show when first element hits top of viewport
    if (firstRect.top <= 0 && lastRect.top >= -175) {
      rabbitImage.style.display = 'block';
      rabbitImage.style.position = 'fixed';
      rabbitImage.style.top = '0';
      const firstElementStyle = window.getComputedStyle(firstImageTextLine);
      const leftPadding = parseFloat(firstElementStyle.paddingLeft);
      rabbitImage.style.left = (firstRect.left + leftPadding) + 'px';
    }
    else if (firstRect.top <= 0 && lastRect.top <= -175) {
      rabbitImage.style.display = 'none';
      rabbitImage.style.position = 'relative';
      rabbitImage.style.left = '0';
    }
    else {
      rabbitImage.style.display = 'block';
      rabbitImage.style.position = 'relative';
      rabbitImage.style.left = '0';
    }
  }

  // Add scroll event listener
  window.addEventListener('scroll', checkVisibility);
  
  // Check initial state
  checkVisibility();
});
      







// BOOT A TOUR

document.addEventListener("DOMContentLoaded", function() {
  // Allowed button labels
  var allowedLabels = ["BOOK A TOUR", "BOOK YOUR TOUR"];

  document.querySelectorAll("a.btn, a.site-nav__dropdown-link").forEach(function(el) {
    var label = el.textContent.trim().toUpperCase();

    if (allowedLabels.includes(label)) {

      // Prevent creating modal multiple times
      if (!document.getElementById("myModal")) {
        var modal = document.createElement("div");
        modal.id = "myModal";
        modal.className = "modal";
        modal.innerHTML = `
          <div class="modal-content">
            <span class="close">&times;</span>
            <div id="iframe_wrapper"></div>
          </div>
        `;
        document.body.appendChild(modal);

        var span = modal.querySelector(".close");

        // Close on X
        span.onclick = function() {
          modal.style.display = "none";
          document.body.classList.remove("book-a-event-modal-open");
        };

        // Close when clicking outside
        window.addEventListener("click", function(event) {
          if (event.target === modal) {
            modal.style.display = "none";
            document.body.classList.remove("book-a-event-modal-open");
          }
        });

        // Init AnyRoad once
        window.anyroad = new AnyRoad({
          container: '#iframe_wrapper',
          plugin: { id: 'rabbit-hole-distillery' }
        });
      }

      // Attach button click → open modal
      el.addEventListener("click", function(e) {
        e.preventDefault();
        document.getElementById("myModal").style.display = "block";
        document.body.classList.add("book-a-event-modal-open");
      });
    }
  });
});
